import Odc from "../Odc";
import { TIME_MASK_ZEROHOUR_ZEROMINUTES } from "../../Forms/Constants/TimeConstants";

export const odcDefaultValues: Odc = {
  Id: 0,
  Gsdb: "",
  Name: "",
  Details: undefined,
  Type: -1, // not a valid type but a placeholder

  // Address
  Street: undefined,
  City: undefined,
  Zipcode: undefined,

  // Country
  CountryId: 0,

  // Region / Area
  Region: undefined,
  ZipArea: undefined,

  // GeoCoordinates
  Latitude: undefined,
  Longitude: undefined,
  MgLatitude: undefined,
  MgLongitude: undefined,

  // Handling times
  DefaultInboundHandlingTime: TIME_MASK_ZEROHOUR_ZEROMINUTES,
  ReturnHandlingTime: TIME_MASK_ZEROHOUR_ZEROMINUTES,
  CountryHandlingTimes: [],
  SupplierHandlingTimes: [],
  SprHandlingTimes: [],
};
